import validate from "/app/node_modules/.pnpm/nuxt@3.21.2_@emnapi+core@1.10.0_@emnapi+runtime@1.11.1_@parcel+watcher@2.5.6_@types+node@18.1_bsf6ps3ma64bq3q7j4emm3nkbu/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/packages/web/middleware/auth.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.21.2_@emnapi+core@1.10.0_@emnapi+runtime@1.11.1_@parcel+watcher@2.5.6_@types+node@18.1_bsf6ps3ma64bq3q7j4emm3nkbu/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}